<!--模拟时钟-->

<template>
  <div class="attr-iclock">
    <div class="iclock-item flex-b-c">
      <span class="iclock-attr">{{ $t('PE.Name') }}</span>
      <span>{{ $t('PE.Analog') }}</span>
    </div>
    <div class="iclock-item flex-b-c">
      <span class="iclock-attr">{{ $t('PE.DisplayMode') }}</span>
      <div style="width: 130px;" class="iclock-attr-child">
        <span>{{ $t('PE.HourMark') }}</span>
        <el-color-picker class="font-color-picker" v-model="media.ext_val_hourCircleColor" size="mini"
          :show-alpha="true" :predefine="predefineColors"></el-color-picker>
        <span>{{ $t('PE.HourHand') }}</span>
        <el-color-picker class="font-color-picker" v-model="media.ext_val_hourHandColor" size="mini" :show-alpha="true"
          :predefine="predefineColors"></el-color-picker>
        <span>{{ $t('PE.MinutesMark') }}</span>
        <el-color-picker class="font-color-picker" v-model="media.ext_val_minCircleColor" size="mini" :show-alpha="true"
          :predefine="predefineColors"></el-color-picker>
        <span>{{ $t('PE.MinutesHand') }}</span>
        <el-color-picker class="font-color-picker" v-model="media.ext_val_minHandColor" size="mini" :show-alpha="true"
          :predefine="predefineColors"></el-color-picker>
        <span>{{ $t('PE.background') }}</span>
        <el-color-picker class="font-color-picker" v-model="media.ext_val_backgroundColor" size="mini"
          :show-alpha="true" :predefine="predefineColors"></el-color-picker>
        <span>{{ $t('PE.secondHand') }}</span>
        <el-color-picker class="font-color-picker" v-model="media.ext_val_secHandColor" size="mini" :show-alpha="true"
          :predefine="predefineColors"></el-color-picker>
      </div>
    </div>
    <div class="iclock-item flex-b-c">
      <span class="iclock-attr">{{ $t('PE.DateAndDay') }}</span>
      <el-checkbox v-model="media.ext_val_showText">{{ $t('PE.Display') }}</el-checkbox>
    </div>
    <div class="iclock-item flex-b-c">
      <span class="iclock-attr">{{ $t('PE.SelectTimeZone') }}</span>
      <el-select v-model="media.ext_val_tzLabel" @change="timelinesChange" :placeholder="$t('basics.PleaseSelect')"
        size="mini" style="width:130px;">
        <el-option v-for="time in timelines" :key="time.label" :label="time.label" :value="time.label"></el-option>
      </el-select>
    </div>
    <div class="iclock-item flex-b-c">
      <span class="iclock-attr">{{ $t('PE.EnterTheAnimation') }}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="iclock-item flex-b-c">
      <span class="iclock-attr">{{ $t('PE.TheEntryTime') }}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>
    <div class="iclock-item flex-b-c">
      <span class="iclock-attr">{{ $t('PE.PlayTime') }}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')"
        size="mini"></el-input-number>
    </div>
  </div>
</template>

<script>
import timelines from '@static/data/timezones.json';
import animations from '../../scripts/animations';
import predefineColors from '@static/data/predefineColors.js';
export default {
  name: "AttrIClock",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      animations,
      timelines,
      predefineColors
    }
  },
  methods: {
    timelinesChange(val) {
      let timelinesItem = this.timelines.find((time) => time.label === val);
      this.media.ext_val_tzId = timelinesItem.id;
      this.media.ext_val_tzCount = timelinesItem.tzCount;
    },
    colorChange(val) {
      console.log(val);
    },
  }
}
</script>

<style lang="scss" scoped>
.attr-iclock {
  padding-right: 4px;

  .iclock-item {
    min-height: 36px;
    margin: 8px 0px;

    .iclock-attr {
      width: 100px;
      // font-family: 'Times New Roman';
      // font-weight: normal;
      // font-stretch: normal;
      // color: #617883;
    }

    .iclock-attr-child {
      width: 130px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;

      span {
        color: #617883;
        font-size: 14px;
      }
    }
  }

  .el-checkbox {
    margin-right: 12px;
  }
}
</style>